import React from 'react'
import { Tabs } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'

interface OrganisationNavProps {
  orgaId: string
}

function isCollaboratorsTab(pathname: string, base: string) {
  if (!pathname.startsWith(`${base}/collaborators`)) return false
  return !pathname.startsWith(`${base}/collaborators/hierarchy`)
}

function isAdhocTramesTab(pathname: string, base: string) {
  return pathname.startsWith(`${base}/etudesadhoc/trames`)
}

function isParamsTab(pathname: string, base: string) {
  return pathname === base || pathname === `${base}/` || pathname === `${base}/params`
}

function isSoftwaresTab(pathname: string, base: string) {
  return (
    pathname === `${base}/softwares` ||
    pathname === `${base}/softwares/` ||
    pathname.startsWith(`${base}/cn/softwaresaccesses`) ||
    pathname.startsWith(`${base}/conquest/softwaresaccesses`) 
  )
}

export function OrganisationNav({ orgaId }: OrganisationNavProps) {
  const history = useHistory()
  const location = useLocation()
  const base = `/organisations/${orgaId}`
  const pathname = location.pathname

  const tabs = [
    {
      key: 'params',
      label: 'Général',
      to: `${base}/params`,
      isActive: isParamsTab(pathname, base),
    },
    {
      key: 'collaborators',
      label: 'Collaborateurs',
      to: `${base}/collaborators`,
      isActive: isCollaboratorsTab(pathname, base),
    },
    {
      key: 'softwares',
      label: 'Accès logiciels',
      to: `${base}/softwares`,
      isActive: isSoftwaresTab(pathname, base),
    },
    {
      key: 'hierarchy',
      label: 'Périmètre de responsabilité',
      to: `${base}/collaborators/hierarchy`,
      isActive: pathname.startsWith(`${base}/collaborators/hierarchy`),
    },
    {
      key: 'adhoc-trames',
      label: 'Ad-hoc trames',
      to: `${base}/etudesadhoc/trames`,
      isActive: isAdhocTramesTab(pathname, base),
    },
    {
      key: 'adhoc-rapports',
      label: 'Ad-hoc rapports',
      to: `${base}/etudesadhoc/rapports`,
      isActive: pathname.startsWith(`${base}/etudesadhoc/rapports`),
    },
  ]

  const activeKey = tabs.find(tab => tab.isActive)?.key

  return (
    <Tabs
      activeKey={activeKey}
      onChange={key => {
        const tab = tabs.find(t => t.key === key)
        if (tab) history.push(tab.to)
      }}
      items={tabs.map(({ key, label }) => ({ key, label }))}
    />
  )
}
